export interface NavigationItem {
  name: string;
  href: string;
  translationKey: string;
}

export const navigation: NavigationItem[] = [
  {
    name: "Projets",
    href: "/#projets",
    translationKey: "projects",
  },
  {
    name: "Offre",
    href: "/#offre",
    translationKey: "offer",
  },
  {
    name: "Contact",
    href: "/#contact",
    translationKey: "contact",
  },
];
